<template>
  <v-row>
    <v-col cols="1"
      ><div class="circle" :style="{ backgroundColor: getColor(el.priority) }">
        {{ el.priority }}
      </div></v-col
    >

    <v-col cols="5">
      <p class="overline mb-1">{{ el.name }}</p>
      <h2 class="text-h6">{{ el.challenge }}</h2>
      <v-btn x-small class="mt-3" @click="submit">Edit</v-btn>
      <v-btn x-small class="mt-3 ml-1" @click="deleteItem">Delete</v-btn>
      <v-btn x-small class="mt-3 ml-1" @click="copy">Copy</v-btn>
    </v-col>
    <v-col cols="2" v-show="attrs.tags">
      <article>
        <p class="text-caption text-uppercase mb-2 mt-2">
          Categories
        </p>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(tag, index) in el.categories"
            light
            :key="`tag-nested-category-${tag}-${index}-${el.id}`"
            small
            class="mr-1 mb-1 yellow lighten-3"
          >
            {{ tag }}</v-chip
          >
        </div>
      </article>
    </v-col>
    <v-col cols="2" v-show="attrs.tags">
      <article>
        <p class="text-caption text-uppercase mb-2 mt-2">
          Tags
        </p>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(tag, index) in el.tags"
            :key="`tag-nested-asset-tag-${tag}-${index}-${el.id}`"
            small
            light
            class="mr-1 mb-1 yellow-lighten-5"
          >
            {{ tag }}</v-chip
          >
        </div>
      </article>
    </v-col>
    <v-col cols="2" v-show="attrs.tags">
      <article v-show="attrs.tags">
        <p class="text-caption text-uppercase mb-2 mt-2">
          Themes
        </p>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(tag, index) in el.themes"
            :key="`tag-nested-asset-themes-${tag}-${index}-${el.id}`"
            small
            light
            class="mr-1 mb-1 yellow-lighten-5"
          >
            {{ tag }}</v-chip
          >
        </div>
      </article>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ChallengeRow",
  props: {
    el: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      default: () => {},
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    isVisible(arr) {
      return arr && arr.length >= 1;
    },
    submit() {
      this.$emit("edit", this.el);
    },
    copy() {
      this.$emit("copy", this.el);
    },
    deleteItem() {
      this.$emit("delete", this.el);
    },
    getColor(priority) {
      switch (priority) {
        case 1:
          return "green";
        case 2:
          return "orange";
        case 3:
          return "red";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  width: 30px;
  height: 30px;
  background: grey;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: relative;
}
</style>
